<script>
import GlobalTransactionDay from "@/components/global_transaction/GlobalTransactionDay.vue";

export default {
  components: {
    GlobalTransactionDay
  },
}
</script>


<template>
  <GlobalTransactionDay
      endpoint="global_transaction/day"
  />
</template>
